// Transitional: session-scoped state moved from localStorage to sessionStorage
// (so it no longer cross-syncs between instances of the same document). Move any
// pre-upgrade values across once on startup, then drop the localStorage copy so
// reopened instances start clean. Safe to delete once all clients have upgraded.
//
// Keys mirror the *_STORAGE_KEY consts in the hooks that own them:
//   sessionsMap         → hooks/useSessions/useSessions.ts
//   documentContextMap  → hooks/useDocumentContext.ts
const LEGACY_SESSION_KEYS = ["sessionsMap", "documentContextMap"];

export function migrateLegacySessionStorage(): void {
  for (const key of LEGACY_SESSION_KEYS) {
    // sessionStorage wins — never clobber current-instance state with a stale copy.
    if (sessionStorage.getItem(key) !== null) continue;
    const legacy = localStorage.getItem(key);
    if (legacy === null) continue;
    try {
      sessionStorage.setItem(key, legacy);
      localStorage.removeItem(key);
    } catch {
      // storage unavailable — leave the legacy value untouched
    }
  }
}
